export default __webpack_public_path__ + "3cb6138aba857ff531680868ae7d47d3.svg";